import React, { useEffect, useState } from "react";
import "./App.css";

// High-fidelity, reusable table for published videos
// Props (optional):
//   data: Array<{ plataforma: string; urlDelVideo: string; fechaDePublicacion: string }>
//   refreshKey: number | string - change this value to trigger a re-fetch
// If `data` is not provided, the component will fetch from the backend using the
// JWT token stored in localStorage under `cliperos_token`.
const VideoPublishedTable = ({ data, refreshKey }) => {
	const [rows, setRows] = useState([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	const fallbackRows = [
		{
			plataforma: "Youtube",
			urlDelVideo: "https://youtube.com/watch?v=AAAAAAAA",
			fechaDePublicacion: "2025-11-01",
		},
		{
			plataforma: "Instagram",
			urlDelVideo: "https://instagram.com/p/BBBBBBBBB",
			fechaDePublicacion: "2025-11-05",
		},
		{
			plataforma: "TikTok",
			urlDelVideo: "https://www.tiktok.com/@user/video/CCCCCCCC",
			fechaDePublicacion: "2025-11-10",
		},
		{
			plataforma: "Youtube",
			urlDelVideo: "https://youtube.com/watch?v=DDDDDDDD",
			fechaDePublicacion: "2025-11-12",
		},
	];

	// Map API shape to table row shape
	useEffect(() => {
		// If parent provides data explicitly, don't fetch from API
		if (Array.isArray(data) && data.length > 0) {
			setRows(data);
			return;
		}

		const token = localStorage.getItem("cliperos_token");
		if (!token) {
			// no token; keep fallback demo rows and don't call API
			setRows(fallbackRows);
			return;
		}

		const fetchVideos = async () => {
			try {
				setLoading(true);
				setError(null);

				const response = await fetch("https://nodeapi.juan1ondonolinks.com/api/videos", {
					method: "GET",
					headers: {
						Authorization: `Bearer ${token}`,
					},
				});

				if (!response.ok) {
					const errorText = await response.text();
					console.error("Failed to fetch videos:", errorText);
					setRows(fallbackRows);
					setError("No se pudieron cargar los videos publicados.");
					return;
				}

				const apiData = await response.json();
				const mapped = (Array.isArray(apiData) ? apiData : []).map((item) => ({
					plataforma: item["Plataforma"] || "-",
					urlDelVideo: item["Video URL"] || "-",
					fechaDePublicacion: item["Fecha de Publicación"] || "-",
				}));

				setRows(mapped.length > 0 ? mapped : fallbackRows);
			} catch (err) {
				console.error(err);
				setRows(fallbackRows);
				setError("No se pudo conectar con el servidor.");
			} finally {
				setLoading(false);
			}
		};

		fetchVideos();
		// We intentionally omit `data` from deps to avoid re-fetching on every parent render.
		// `refreshKey` and initial mount control when we hit the API.
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [refreshKey]);

	const rowsToRender = rows.length > 0 ? rows : fallbackRows;

	return (
		<div className="video-table-container">
			{loading && <div className="video-table-status">Cargando videos…</div>}
			{error && <div className="video-table-status video-table-status--error">{error}</div>}
			<table className="video-table">
				<thead>
					<tr>
						<th className="video-table-col-platform">Plataforma</th>
						<th className="video-table-col-url">URL del Video</th>
						<th className="video-table-col-date">Fecha de Publicación</th>
					</tr>
				</thead>
				<tbody>
					{rowsToRender.map((row, index) => (
						<tr key={index} className="video-table-row">
							<td>{row.plataforma}</td>
							<td className="video-table-url-cell">{row.urlDelVideo}</td>
							<td>{row.fechaDePublicacion}</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};

export default VideoPublishedTable;
